import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { WebsiteDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, { id: string; payload: Partial<WebsiteDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.WEBSITE}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'websites-with-join', id: 'GET-JOIN' },
            { type: 'website', id: 'GET-ID' },
            { type: 'websites', id: 'GET' },
        ],
    });
